import { ToastContainer } from 'react-toastify'
import styled from 'styled-components'

export const ToastContainerComponent = styled(ToastContainer)`
    width: min-content;

    .Toastify__toast-container {
        width: auto;
    }

    .Toastify__toast {
        box-shadow: 0px 0px 0px rgb(0 0 0 / 0%);
        margin: 0;
        padding: 0;
    }

    .Toastify__toast--success,
    .Toastify__toast--warning,
    .Toastify__toast--error {
        background: transparent;
    }

    .Toastify__toast--info {
        background: var(--oh-grey) !important;
        border-left: 4px solid var(--oh-green) !important;
        border-radius: 0px 4px 4px 0px !important;
        font-family: Avenir !important;
        white-space: nowrap;
        text-transform: lowercase;
        min-height: 40px !important;
        width: max-content !important;
    }
`
